import {TagType} from '../../model';
import {Tag} from '../atoms';
import {formatDateUTC} from "../../utils/lib";
import {InvoiceCallback} from "../../model";
import {useTimezone} from '../../hooks';

type InvoiceCallbackRowProps = {
    callback: InvoiceCallback;
}

export const InvoiceCallbackRow = ({callback}: InvoiceCallbackRowProps) => {
    const timezone = useTimezone();
    return (
        <tr className="h-12">
            <td>{callback.id} </td>
            <td>
                <Tag type={TagType.Neutral}>{callback.status}</Tag>
            </td>
            <td>
                <Tag type={TagType.Neutral}>{callback.invoiceStatus}</Tag>
            </td>
            <td> {formatDateUTC(callback.createDate, 'long', timezone)}</td>
            <td> {formatDateUTC(callback.executionDate, 'long', timezone)}</td>
        </tr>
    );
};
